require('./payrollLoanRequestWorkingTime.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
// @commons
const { OKInput } = require('commonsComponents/OKInput');
// @core
const { formatText, FormattedText } = require('core/i18n').i18n;
// @constants
const {
    DEFAULT_LOANS_DECIMALS_LENGTH,
    MAXIMUM_VALUE_YEARS_SENORITY,
    MAXIMUM_VALUE_MONTHS_SENORITY,
    payrollLoanJobs: {
        PAYROLL_LOAN_JOB_PERMANENT_EMPLOYEE,
        PAYROLL_LOAN_JOB_TEMPORAL_EMPLOYEE,
        PAYROLL_LOAN_JOB_STATE_EMPLOYEE,
        PAYROLL_LOAN_JOB_INTERNAL_STATE_EMPLOYEE,
    },
    payrollLoanJobTypeKeys: {
        OWN_ACCOUNT_DRAGO_OPTION_KEY
    },
} = require('../../../../../loansConstants/index');
const { NUMBER_REGEX } = require('constants/index');

class payrollLoanRequestWorkingTime extends React.Component {

    constructor(props) {
        super(props);

        this.handleMonthsChange = this.handleMonthsChange.bind(this);
        this.handleYearsChange = this.handleYearsChange.bind(this);

    }

    componentDidMount() {
        const {       
            formHandlers: {
                handleTotalSenorityFieldsDirty,
                handleSenorityFieldsDirty
            }, 
            immContractLoan 
        } = this.props;
        const status = immContractLoan.get("totalSenorityYears") || immContractLoan.get("totalSenorityMonths");
        const statusSenority = immContractLoan.get("companyYears") || immContractLoan.get("companyMonths");
        this.updateStateFields(handleTotalSenorityFieldsDirty, !!status);
        this.updateStateFields(handleSenorityFieldsDirty, !!statusSenority);
    }

    convertStringValueToNumberValue(value) {
        return value ? parseInt(value) : value;
    }

    handleYearsChange(evt, type = 'yearsWorkingTime') {
        const { formHandlers } = this.props;
        const value = evt.target.value;
        if (NUMBER_REGEX.test(value)) {
            const numberValue = this.convertStringValueToNumberValue(this.splitPayrollLoan(value));
            formHandlers.handleCompanyYears(numberValue, type, true);
        } else {
            formHandlers.handleCompanyYears('', type, true);
        }
    }

    handleMonthsChange(evt, type = 'monthsWorkingTime') {
        const { formHandlers } = this.props;    
        const value = evt.target.value;
        if (NUMBER_REGEX.test(value)) {
            const numberValue = this.convertStringValueToNumberValue(this.splitPayrollLoan(value));
            formHandlers.handleCompanyMonths(numberValue, type, true);
        } else {
            formHandlers.handleCompanyMonths('', type, true);
        }
    }

    buildOldSeniority() {

        const {
            immContractLoan,
        } = this.props;

        const { formHandlers } = this.props;

        const job = immContractLoan.get('job');

        const showSeniorityFields = [
            PAYROLL_LOAN_JOB_PERMANENT_EMPLOYEE,
            PAYROLL_LOAN_JOB_TEMPORAL_EMPLOYEE,
            PAYROLL_LOAN_JOB_STATE_EMPLOYEE,
            PAYROLL_LOAN_JOB_INTERNAL_STATE_EMPLOYEE
        ].includes(job);

        const yearsWorkingTime = immContractLoan.get('yearsWorkingTime');
        const monthsWorkingTime = immContractLoan.get('monthsWorkingTime');

        if ((yearsWorkingTime || monthsWorkingTime) && !showSeniorityFields) {
            formHandlers.handleCompanyYears('', 'yearsWorkingTime', false);
            formHandlers.handleCompanyMonths('', 'monthsWorkingTime', true);
        }

        const isEmpty = !yearsWorkingTime && !monthsWorkingTime; // required here too for Bussiness rule
        const error = immContractLoan.get('validate') && isEmpty && (
            <FormattedText
                className="payroll-loan-request-step-one__error"
                value="payrollLoanRequestStepOne-seniorityError"
            />
        );

        return showSeniorityFields && (
            <div className="row payroll-loan-request-step-one__input-fields__senior-block">
                <div className="col-xs-6 payroll-loan-request-step-one__container-without-left">
                    <FormattedText
                        className="payroll-loan-request-step-one__input-fields__senior-label"
                        value="payrollLoanRequestStepOne-seniorityTitle"
                    />
                    <div className="row payroll-loan-request-step-one__input-fields__senior-form">
                        <div className="col-xs-3 payroll-loan-request-step-one__input-fields__senior-input">
                            <OKInput
                                value={yearsWorkingTime}
                                name="payrollLoanInputYears"
                                onChange={event => this.handleYearsChange(event, 'yearsWorkingTime')}
                                maxLength={DEFAULT_LOANS_DECIMALS_LENGTH}
                            />
                        </div>
                        <div className="col-xs-3 payroll-loan-request-step-one__input-fields__senior-input--label">
                            <FormattedText value="payrollLoanRequestStepOne-years" />
                        </div>
                        <div className="col-xs-3 payroll-loan-request-step-one__input-fields__senior-input">
                            <OKInput
                                value={monthsWorkingTime}
                                name="payrollLoanInputMonths"
                                onChange={event => this.handleMonthsChange(event, 'monthsWorkingTime')}
                                maxLength={DEFAULT_LOANS_DECIMALS_LENGTH}
                            />
                        </div>
                        <div className="col-xs-3 payroll-loan-request-step-one__input-fields__senior-input--label">
                            <FormattedText value="payrollLoanRequestStepOne-months" />
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 payroll-loan-request-step-one__container-without-left">
                    {error}
                </div>
            </div>
        );
    }

    splitPayrollLoan(payrollLoanData) {
        if(!payrollLoanData){
            return 0;
        }
        return typeof payrollLoanData  === "string" ? parseInt(payrollLoanData.split(' ')[0]) : payrollLoanData;
    }

    isErrorInYearsOrMonths(yearValue, monthValue, validateTimeError, showErrorMessage, type) {
        const { immContractLoan } = this.props;

        const response = {
            errorMonths: false,
            errorYears: false,
            errorText: ''
        };

        const years = this.splitPayrollLoan(yearValue);
        const months = this.splitPayrollLoan(monthValue);
        const totalSenorityFieldsIsDirty = immContractLoan.get("totalSenorityFieldsIsDirty");
        const senorityFieldsIsDirty = immContractLoan.get("senorityFieldsIsDirty");
        const isModifiedInputField = type === "totalSenority" ? totalSenorityFieldsIsDirty : senorityFieldsIsDirty;

        if (years > MAXIMUM_VALUE_YEARS_SENORITY || months > MAXIMUM_VALUE_MONTHS_SENORITY) {
            if (years > MAXIMUM_VALUE_YEARS_SENORITY) {
                response.errorYears = true;
                response.errorText = formatText("payrollLoanRequestStepOne-payrollLoanRequestStepOne_workingTimeMaximunYearsError");
            }
            if (months > MAXIMUM_VALUE_MONTHS_SENORITY) {
                response.errorMonths = true;
                response.errorText = `${response.errorText} ${formatText("payrollLoanRequestStepOne-payrollLoanRequestStepOne_workingTimeMaximunMonthsError")}`;
            }

        }else if(years === 0 && months === 0 && isModifiedInputField) {
            response.errorMonths = true;
            response.errorYears = true;
        } else if (validateTimeError && totalSenorityFieldsIsDirty) {
            let companyYears = this.splitPayrollLoan(immContractLoan.get('companyYears'));
            let companyMonths = this.splitPayrollLoan(immContractLoan.get('companyMonths'));
            let totalSenorityYears = this.splitPayrollLoan(immContractLoan.get('totalSenorityYears'));
            let totalSenorityMonths = this.splitPayrollLoan(immContractLoan.get('totalSenorityMonths'));

            const errorValuesMessage = formatText("payrollLoanRequestStepOne-payrollLoanRequestStepOne_workingTimeActualTimeBiggertotalTimeError");
            if (totalSenorityYears < companyYears || (totalSenorityYears === companyYears && totalSenorityMonths < companyMonths)) {
                response.errorYears = true;
                response.errorMonths = true;
                response.errorText = showErrorMessage ? errorValuesMessage : "";
            }
        }

        return response;
    }

    buildSeniorError(errorText) {
        return (
            <div className="payroll-loan-request-step-one__error">
                {errorText}
            </div>
        );
    }

    handleBlurWrokingTimeInput(type, lastTypeOfTime, onBlurFunction, onDirtyFunction, inputType) {
        const { immContractLoan } = this.props;

        onBlurFunction(type, lastTypeOfTime);
        if (!!onDirtyFunction) {
            let status;
            if (inputType === "totalSenority"){
                status = immContractLoan.get("totalSenorityYears") || immContractLoan.get("totalSenorityMonths");
            }else {
                status = immContractLoan.get("companyYears") || immContractLoan.get("companyMonths");
            }
            onDirtyFunction({ status: !!status });
        }
    }

    updateStateFields(onDirtyFunction, status){
        onDirtyFunction({ status })
    }

    buildGenericNewInputsComponents(params) {
        const {
            immContractLoan,
        } = this.props;
        
        const {
            inputLabel,
            monthsFieldName,
            monthsValue,
            onChangeMonthsType,
            onChangeYearsType,
            onBlurFunction,
            showPrimaryTitle,
            titleInputs,
            yearsFieldName,
            yearsValue,
            validErrorMessage,
            validateTimeError,
            onDirtyFunction,
            onFocusFunction,
            showErrorMessage,
            type
        } = params;

        const years = this.splitPayrollLoan(yearsValue);
        const months = this.splitPayrollLoan(monthsValue);
        const isEmpty = !years && !months;
        const validate = immContractLoan.get('validate');

        const errorInYearsOrMonths = this.isErrorInYearsOrMonths(yearsValue, monthsValue, validateTimeError, showErrorMessage, type);
        const errorMessage = (errorInYearsOrMonths.errorText || !showErrorMessage) && !isEmpty ? errorInYearsOrMonths.errorText : formatText(validErrorMessage);
        const errorMonths = errorInYearsOrMonths.errorMonths || (validate && isEmpty);
        const errorYears = errorInYearsOrMonths.errorYears || (validate && isEmpty);

        const errorComponent = errorMonths || errorYears ? this.buildSeniorError(errorMessage) : null;

        const yearsPlaceholder = formatText("payrollLoanRequestStepOne-payrollLoanRequestStepOne_workingTimeYearsPlaceholder");
        const monthsPlaceholder = formatText("payrollLoanRequestStepOne-payrollLoanRequestStepOne_workingTimeMonthsPlaceholder");
        const lastTypeOfYears = yearsPlaceholder.split(' ')[1];
        const lastTypeOfMonths = monthsPlaceholder.split(' ')[1];

        return (
            <div className="row payroll-loan-request-step-one__input-fields__senior-block">
                <div className="col-xs-12 payroll-loan-request-step-one__container-without-left">
                    {showPrimaryTitle &&
                        <FormattedText
                            className="payroll-loan-request-step-one__title-fields"
                            value={titleInputs}
                        />
                    }
                    <FormattedText
                        className="payroll-loan-request-step-one__input-fields__senior-label"
                        value={inputLabel}
                    />
                    <div className="row payroll-loan-request-step-one__input-fields__senior-form">
                        <div className="col-xs-3 payroll-loan-request-working-time__senior-new-input">
                            <OKInput
                                errorState={errorYears}
                                value={yearsValue}
                                name={yearsFieldName}
                                onChange={event => this.handleYearsChange(event, onChangeYearsType)}
                                onBlur={() => this.handleBlurWrokingTimeInput(onChangeYearsType, lastTypeOfYears, onBlurFunction, onDirtyFunction, type)}
                                onFocus={() => onFocusFunction(onChangeYearsType)}
                                maxLength={DEFAULT_LOANS_DECIMALS_LENGTH}
                                placeholder={yearsPlaceholder}
                            />
                        </div>
                        <div className="col-xs-3 payroll-loan-request-working-time__senior-new-input">
                            <OKInput
                                errorState={errorMonths}
                                value={monthsValue}
                                name={monthsFieldName}
                                onChange={event => this.handleMonthsChange(event, onChangeMonthsType)}
                                onBlur={() => this.handleBlurWrokingTimeInput(onChangeMonthsType, lastTypeOfMonths, onBlurFunction, onDirtyFunction, type)}
                                onFocus={() => onFocusFunction(onChangeMonthsType)}
                                maxLength={DEFAULT_LOANS_DECIMALS_LENGTH}
                                placeholder={monthsPlaceholder}
                            />
                        </div>
                    </div>
                </div>
                {errorComponent}
            </div>
        );
    }

    buildNewSeniority() {
        const {
            immContractLoan,
            formHandlers: {
                handleWorkingTimeWrapper,
                handleWorkingTimeWrapperFocus,
                handleSenorityFieldsDirty,
            }
        } = this.props;

        const params = {
            inputLabel: "payrollLoanRequestStepOne-payrollLoanRequestStepOne_actualWorkTime",
            monthsFieldName: "payrollLoanInputMonths",
            monthsValue: immContractLoan.get('companyMonths'),
            onChangeMonthsType: "companyMonths",
            onChangeYearsType: "companyYears",
            onDirtyFunction: handleSenorityFieldsDirty,
            onBlurFunction: handleWorkingTimeWrapper,
            onFocusFunction: handleWorkingTimeWrapperFocus,
            showPrimaryTitle: true,
            titleInputs: "payrollLoanRequestStepOne-payrollLoanRequestStepOne_workingTimeTitle",
            yearsFieldName: "payrollLoanInputYears",
            yearsValue: immContractLoan.get('companyYears'),
            validErrorMessage: "payrollLoanRequestStepOne-payrollLoanRequestStepOne_actualWorkTimeError",
            validateTimeError: true,
            showErrorMessage: false,
            type: "senority"
        }

        return this.buildGenericNewInputsComponents(params);
    }

    buildNewTotalSeniority() {
        const {
            immContractLoan,
            formHandlers: {
                handleTotalSenorityFieldsDirty,
                handleWorkingTimeWrapper,
                handleWorkingTimeWrapperFocus,
            }
        } = this.props;

        if (immContractLoan.get('newJobType') !== OWN_ACCOUNT_DRAGO_OPTION_KEY) {
            const params = {
                inputLabel: "payrollLoanRequestStepOne-payrollLoanRequestStepOne_allWorkingTime",
                monthsFieldName: "payrollLoanMonthsTotalWorkingTime",
                monthsValue: immContractLoan.get('totalSenorityMonths'),
                onChangeMonthsType: "totalSenorityMonths",
                onChangeYearsType: "totalSenorityYears",
                onDirtyFunction: handleTotalSenorityFieldsDirty,
                onBlurFunction: handleWorkingTimeWrapper,
                onFocusFunction: handleWorkingTimeWrapperFocus,
                yearsFieldName: "payrollLoanYearsTotalWorkingTime",
                yearsValue: immContractLoan.get('totalSenorityYears'),
                validErrorMessage: "payrollLoanRequestStepOne-payrollLoanRequestStepOne_allWorkingTimeError",
                validateTimeError: true,
                showErrorMessage: true,
                type: "totalSenority"
            }

            return this.buildGenericNewInputsComponents(params);
        }
    }

    render() {
        const { isDragoFeature } = this.props;
        const workingTime = isDragoFeature ? this.buildNewSeniority() :
            this.buildOldSeniority();
        const totalWorkingTime = isDragoFeature && this.buildNewTotalSeniority();

        return (
            <div className="col-xs-12 payroll-loan-request-working-time__container">
                {workingTime}
                {totalWorkingTime}
            </div>
        );
    }
}

payrollLoanRequestWorkingTime.propTypes = {
    formHandlers: PropTypes.object.isRequired,
    immContractLoan: PropTypes.object.isRequired,
    isDragoFeature: PropTypes.bool.isRequired,
};

module.exports = payrollLoanRequestWorkingTime;
